__turbopack_context__.v({
  "body": "ActivityNavigationGrid-module-scss-module__3FvZRG__body",
  "buttonGroup": "ActivityNavigationGrid-module-scss-module__3FvZRG__buttonGroup",
  "header": "ActivityNavigationGrid-module-scss-module__3FvZRG__header",
  "heading": "ActivityNavigationGrid-module-scss-module__3FvZRG__heading",
  "headingGroup": "ActivityNavigationGrid-module-scss-module__3FvZRG__headingGroup",
  "inner": "ActivityNavigationGrid-module-scss-module__3FvZRG__inner",
  "navButton": "ActivityNavigationGrid-module-scss-module__3FvZRG__navButton",
  "root": "ActivityNavigationGrid-module-scss-module__3FvZRG__root",
  "slide": "ActivityNavigationGrid-module-scss-module__3FvZRG__slide",
  "status": "ActivityNavigationGrid-module-scss-module__3FvZRG__status",
  "swiper": "ActivityNavigationGrid-module-scss-module__3FvZRG__swiper",
  "track": "ActivityNavigationGrid-module-scss-module__3FvZRG__track",
});
